import { Component, OnInit, ViewChild, OnDestroy, ElementRef, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { filter } from 'rxjs/operators';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { QrCodeService } from '../../../../core/services/qr-input-service/qr-input.service';
import { GoogleAnalyticsService } from '../../../../core/services/google-analytics-service/google-analytics.service';
import { GlobalConstants } from '../../../constants/global.constant';

@Component({
  selector: 'app-panther-lake-homepage',
  templateUrl: './panther-lake-homepage.component.html',
  styleUrls: ['./panther-lake-homepage.component.scss']
})
export class PantherLakeHomepageComponent implements OnInit, OnDestroy, AfterViewChecked {

  activeTab: string = 'onboarding';
  compareButtonText: string = '';
  isPantherLakeStd: boolean = false;
  setIntelDisplayOneFont: boolean = false;
  private ngUnsubscribe = new Subject<boolean>();
  storeLogo: string;
  isStoreLogo: boolean = false;
  @ViewChild('compareDevicesRef') compareDevicesComponent: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private libraryV2DataService: LibraryV2DataService,
    private qrCodeService: QrCodeService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      takeUntil(this.ngUnsubscribe)
    ).subscribe(() => {
      if (this.compareDevicesComponent) {
        this.compareDevicesComponent.checkDeviceDetailsFlag = true;
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.activeTab = params?.['activeTab'] || 'onboarding';
    });
    this.isPantherLakeStd = this.qrCodeService.isPantherLakeStd;
    this.compareButtonText = this.libraryV2DataService.getStaticText('tr_compareText');
    this.setIntelDisplayOneFont = this.qrCodeService.setenusLang();
    this.qrCodeService.storelogoimgdata.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data) => {
          if (data && data !== '') {
            this.storeLogo = data;
            this.isStoreLogo = false;
          }
          else {
            this.isStoreLogo = true;
          }
        });
  }

  ngAfterViewChecked(): void {
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onNavClick(newTab: string) {
    if (this.compareDevicesComponent) {
      this.compareDevicesComponent.checkDeviceDetailsFlag = true;
    }
    if (this.activeTab === 'va' && newTab !== 'va') {
      let isVaExit = true;      
      window.dispatchEvent(new CustomEvent('VA_TAB_EXIT_EVENT', { detail: isVaExit }));
    }
  }

  setActiveTab(activeTab: string) {
    this.activeTab = activeTab;
  }

  gotoComparePage() {
    this.router.navigate(['compare']);
    this.googleAnalyticsService.sendGtag( GlobalConstants.COMPARE_DEVICE, { event_category: GlobalConstants.COMPARE_DEVICE, event_label: GlobalConstants.COMPARE_DEVICE, 'compare_device': 1 });
  }

}
